import { createContext, useContext } from 'react'

export interface LanguageContextType {
  language: string
  setLanguage: (lang: string) => void
  content: any
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined)

export const useLanguageContext = () => {
  const context = useContext(LanguageContext)
  if (context === undefined) {
    throw new Error('useLanguageContext must be used within a LanguageProvider')
  }
  return context
} 